'use client';

import React, { useState } from 'react';
import { BloodVisionAddOn } from './types/bloodVision';
import { CaretUp, TickBlue } from 'assets/icons';
import { useBloodVision } from '../BloodVisionContext';
import styles from './AddOnList.module.css';

interface AddOnListProps {
  addOns: BloodVisionAddOn[];
  selectedAddOns: number[];
  toggleAddOn: (id: number) => void;
}

const AddOnList: React.FC<AddOnListProps> = ({
  addOns,
  selectedAddOns,
  toggleAddOn,
}) => {
  const [expandedAddOns, setExpandedAddOns] = useState<number[]>([]);
  const { isLoading, zipCode, isZipValid, checkoutAllowed } = useBloodVision();

  // Check if user has entered a valid zipcode
  const hasValidZipCode = zipCode && zipCode.length === 5 && isZipValid;

  const toggleParameters = (id: number) => {
    setExpandedAddOns((prev) =>
      prev.includes(id)
        ? prev.filter((addOnId) => addOnId !== id)
        : [...prev, id],
    );
  };

  return (
    <div>
      {addOns.map((addOn) => (
        <div className={styles.addOnContainer} key={addOn.id}>
          <div className={styles.addOnHeader}>
            <div className={styles.addOnInfo}>
              <h4 className={styles.addOnTitle}>{addOn.name}</h4>
              <p className={styles.addOnDescription}>{addOn.description}</p>
            </div>
            <div className={styles.addOnPrice}>{addOn.price}</div>
          </div>
          <div className={styles.parameterSection}>
            <button
              className={styles.viewParametersButton}
              onClick={() => toggleParameters(addOn.id)}
              data-state={expandedAddOns.includes(addOn.id) ? 'open' : 'closed'}
            >
              View Parameters
              <CaretUp fill="rgba(0, 0, 0, 0.5)" width={10} height={10} />
            </button>
            <button
              className={styles.addButton}
              data-selected={selectedAddOns.includes(addOn.id)}
              onClick={() => toggleAddOn(addOn.id)}
              disabled={isLoading || !hasValidZipCode || !checkoutAllowed}
            >
              {selectedAddOns.includes(addOn.id) ? 'Added' : 'Add'}
              {selectedAddOns.includes(addOn.id) ? <TickBlue /> : ''}
            </button>
          </div>
          {/* Always render the list but control its visibility with CSS */}
          <div
            className={styles.parametersList}
            data-state={expandedAddOns.includes(addOn.id) ? 'open' : 'closed'}
          >
            {addOn.blood_markers.map((marker, index) => (
              <div className={styles.parameter} key={index}>
                {marker}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddOnList;
